<template>
    <div id="contact">
        <div class="flex flex-col items-center justify-center w-full h-full max-w-2xl pr-8 mx-auto text-center">
            <p class="my-5 text-base font-medium tracking-tight text-[#f97316] uppercase">Ready to Order or Adopt?
            </p>
            <h2
                class="text-4xl font-extrabold leading-10 tracking-tight text-gray-900 sm:text-5xl sm:leading-none md:text-6xl lg:text-5xl xl:text-6xl">
                Get in Touch With Us</h2>
            <p class="my-6 text-xl font-medium text-gray-500">Whether you're looking to bring home a new pet or order our products, we're here to help. Contact us now and let's make it happen.</p>
        </div>

        <div class="flex flex-col items-center justify-center max-w-2xl mx-auto xl:flex-row xl:max-w-1/2">
            <div class="card">
                <form class="form" @submit.prevent="writeUserData">
                    <div class="group">
                        <input placeholder="" type="text" name="name" id="name" v-model="name" required>
                        <label for="name">Name</label>
                    </div>

                    <div class="group">
                        <input placeholder="" type="email" id="email" v-model="email" name="email">
                        <label for="email">Email</label>
                    </div>

                    <div class="group">
                        <input placeholder="" type="tel" id="tel" name="tel" v-model="tel" required pattern="0\d{9}"
                            title="Please enter a 10-digit telephone number starting with 0. For example: 0723456789">
                        <label for="email">Contact Number</label>
                    </div>

                    <div class="group">
                        <select name="purpose" id="purpose" v-model="purpose" required>
                            <option value="" hidden selected disabled style="color:rgb(99, 102, 102)">Select Purpose
                            </option>
                            <option value='Adopt'>Adopt</option>
                            <option value="Purchase">Purchase</option>
                        </select>
                        <label for="purpose">Purpose</label>
                    </div>

                    <div class="group">
                        <textarea placeholder="" id="note" name="note" rows="5" v-model="note" required></textarea>
                        <label for="note">Note</label>
                    </div>
                    <button type="submit">Send</button>
                </form>
                <ConfirmationModal ref="confirmationModal" class="flex justify-center">
                    <h2>Form Submitted</h2>
                    <p>Your form has been successfully submitted!</p>
                </ConfirmationModal>
            </div>

        </div>
    </div>



</template>

<script>
import { mapActions } from 'vuex';
import ConfirmationModal from './ConfirmationModal.vue';

export default {
    components: {
        ConfirmationModal
    },
    data() {
        return {
            name: '',
            email: '',
            note: '',
            purpose: '',
            tel: '',
            error: null,
        };
    },
    methods: {
        ...mapActions(['saveContactForm']),

        async writeUserData() {
            try {
                await this.saveContactForm({ name: this.name, email: this.email, tel: this.tel, note: this.note, purpose: this.purpose });
                this.name = '';
                this.email = '';
                this.note = '';
                this.purpose = '';
                this.tel = '';
                this.error = null;

                // Show the confirmation modal
                this.$refs.confirmationModal.open();
            } catch (error) {
                this.error = error.message;
            }
        }
    }
}
</script>

<style scoped>
.card {
    background-color: #fff;
    border-radius: 10px;
    padding: 20px;
    width: 90%;
    display: flex;
    flex-direction: column;
}

.title {
    font-size: 24px;
    font-weight: 600;
    text-align: center;
}

.form {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
}

.group {
    position: relative;
}

.form .group label {
    font-size: 14px;
    color: rgb(99, 102, 102);
    position: absolute;
    top: -10px;
    left: 10px;
    background-color: #fff;
    transition: all .3s ease;
}

.form .group input,
.form .group select,
.form .group textarea {
    padding: 10px;
    border-radius: 5px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    margin-bottom: 20px;
    outline: 0;
    width: 100%;
    background-color: transparent;
}

.form .group input:placeholder-shown+label,
.form .group select:placeholder-shown+label,
.form .group textarea:placeholder-shown+label {
    top: 10px;
    background-color: transparent;
}

.form .group input:focus,
.form .group select:focus,
.form .group textarea:focus {
    border-color: #f97316;
}

.form .group input:focus+label,
.form .group select:focus+label,
.form .group textarea:focus+label {
    top: -10px;
    left: 10px;
    background-color: #fff;
    color: #f97316;
    font-weight: 600;
    font-size: 14px;
}

.form .group textarea {
    resize: none;
    height: 100px;
}

.form button {
    color: #f97316;
    font-weight: bolder;

    border-width: 1px;
    border-color: #f97316;
    border-radius: 5px;
    padding: 10px;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.form button:hover {
    background-color: #f97316;
    color: #fff;
}


/* additions and modifications */

.form .group.flex {
    display: flex;
    align-items: center;
    /* Align items vertically */
}

.form .group.flex select {
    padding: 10px;
    border-radius: 5px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    margin-bottom: 20px;
    outline: 0;
    background-color: transparent;
    width: auto;
    /* Adjust width as needed */
}

/* Adjust styles for the phone input */
.form .group.flex input {
    flex-grow: 1;
    /* Grow to fill remaining space */
}

.form .group.flex label {
    font-size: 14px;
    color: rgb(99, 102, 102);
    position: absolute;
    top: -10px;
    left: 90px;
    background-color: #fff;
    transition: all .3s ease;
}

.form .group.flex input:focus+label {
    top: -10px;
    left: 90px;
    background-color: #fff;
    color: #f97316;
    font-weight: 600;
    font-size: 14px;
}
</style>